/**
 * SMSWiser Template ID computation (browser).
 * Replicates SMSWiser's client-side algorithm: CRC32 (IEEE 802.3) of UTF-8 bytes.
 * Same text = same template ID. Used to map texts to performance tags (tagsByTextId).
 *
 * See docs/SMSWISER_TEMPLATE_ID.md for algorithm details.
 * For Media Devoted | Created By Ciro Autiero
 */

const CRC32_TABLE: number[] = (() => {
  const table: number[] = [];
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) {
      c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    }
    table[n] = c >>> 0;
  }
  return table;
})();

/**
 * Compute SMSWiser Template ID for an SMS text.
 * Matches backend computeSmswiserTemplateId and SMSWiser's "Template ID:" value.
 *
 * @param text - Raw SMS text (UTF-8 encoded for hashing)
 * @returns 8-char lowercase hex string (e.g. "3610a686")
 */
export function computeSmswiserTemplateId(text: string): string {
  const bytes = new TextEncoder().encode(text);
  let crc = 0xffffffff;
  for (let i = 0; i < bytes.length; i++) {
    crc = CRC32_TABLE[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
  }
  const hex = ((crc ^ 0xffffffff) >>> 0).toString(16);
  return hex.padStart(8, '0');
}
